<template>
	<div class="page container">
		<v2-back-btn />
		<div class="page__info">
			<div class="page__info--title">
				Edit deals
			</div>
		</div>
		<div>
			<edit-pack-deals :deal-pack="dealPack" />
		</div>
	</div>
</template>

<script>

	import V2BackBtn from '@/components/v2/ui/V2BackBtn';
	import EditPackDeals from '@/components/dealPacks/EditPackDeals';
	import routeParams from '@/mixins/routeParams';
	import api from '@/services/api';

	export default {
		layout: 'v2default',
		metaInfo: {
			title: 'Edit deals'
		},
		components: {
			EditPackDeals,
			V2BackBtn
		},
		mixins: [routeParams],
		data () {
			return {
				dealPack: null,
				isWaiting: undefined
			};
		},
		computed: {
			getDealPackTitle () {
				return  this.dealPack?.title;
			},
			getBreadcrumbs () {
				return [
					{
						path: '/teaching',
						text: 'Teaching'
					},
					{
						path: this.getDealPacksRoute,
						text: 'Deal Packs'
					},
					{
						path: this.getDealPackRoute,
						text: this.getDealPackTitle
					},
					{
						path: `${this.getDealPackRoute}/deals`,
						text: 'Deals'
					}
				];
			}
		},
		created () {
			this.fetchDealPackData();
		},
		methods: {
			async fetchDealPackData () {
				const dealPack = await api.teaching.getDealPackById({
					dealPackId: this.getDealPackId
				});
				if (!dealPack) {
					this.$store.commit('ui/showError');
					return false;
				}
				this.dealPack = dealPack;
				this.$store.commit('ui/setBreadcrumbs', {
					breadcrumbs: this.getBreadcrumbs
				});
				this.$store.commit('ui/setLoadingIsHidden');
			}
		}
	};

</script>

<style lang="scss" scoped>
.page__info {
  margin-bottom: 24px;
}
</style>
